module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/@fuse/components/navigation/horizontal/nav-collapse/nav-horizontal-collapse.component.scss
// module id = ./src/@fuse/components/navigation/horizontal/nav-collapse/nav-horizontal-collapse.component.scss
// module chunks = main